import * as ReactGA from 'react-ga';

export const register = (id: string) => {
  ReactGA.initialize(id, {
      debug: false,
  });
  ReactGA.pageview(window.location.pathname + window.location.search);
};

export const trackEvent = (action, category, options = {}) => {
  ReactGA.event({
    action,
    category,
    ...options
  });
};



// WEBPACK FOOTER //
// ./src/modules/google_analytics/index.web.ts